// Will truncate string accodring to param maxLen. Also adds three dots at the end...
export const truncateString = (str: string, maxLen: number) => {
	if (str.length > maxLen) {
		const formattedString = str.substring(0, maxLen);
		const trailingDotsString = "...";
		const resultFormatted = formattedString.concat(trailingDotsString);
		return resultFormatted;
	}
	return str;
};

// Will replace comma (,) with dot(.)
export const commaToDotSeparator = (str: string) => {
	const transformedString = str.replace(",", ".");
	return transformedString;
};

// Will remove whitespace in strings
export const whiteSpaceRemover = (str: string) => {
	const transformedString = str.replace(/\s/g, "");
	return transformedString;
};

export const removeHyphen = (str: string) => str.replace("-", "");

export const replaceNullValueWithHyphen = (value: string | null) => value || "-";

export const formatOrgOrPersonNumber = (str: string) => {
	if (str.length === 12) {
		const strWithDash = str.replace(/(\d{8})/, "$1-");
		return strWithDash.substring(2, strWithDash.length);
	}
	if (str.length === 10) {
		return str.replace(/(\d{6})/, "$1-");
	}
	return str;
};

export const formatFullAddress = (
	address1: string | null,
	// biome-ignore lint/style/useDefaultParameterLast: Not sure what to do here. Doesnt make sense to move it and doesnt make sense to keep it. Maybe make it a required parameter since it sort of has to be anyway.
	address2: string | null = null,
	zipCode: string | null,
	city: string | null,
) => {
	const mandatoryAddress = address1 === null ? "" : `${address1},`;
	const possibleAddressLine = address2 === null ? "" : ` ${address2},`;
	const regexZipCode = /(^)(\d{3})/;
	const zip = zipCode === null ? "" : zipCode.replace(regexZipCode, "$1 $2 ");
	const currentCity = city === null ? "" : ` ${city}`;

	return `${mandatoryAddress}${possibleAddressLine}${zip}${currentCity}`;
};

export const formatClearingAndAccountNumber = (clearing: string, account: string) =>
	`${clearing} - ${account}`;

export const formatCreditCardNumber = (cardNumber: string | null) =>
	!cardNumber
		? ""
		: cardNumber
				.replace(/(.{4})/g, "$1 ")
				.replace(/\*/g, "X")
				.trim();

export const formatValidThru = (validTo: string) => {
	const pattern = /^..(\d{2})-(\d{2})-(\d{2})/;
	if (!validTo || !validTo.match(pattern)) {
		return null;
	}
	return validTo.replace(pattern, "$2/$1");
};

// Used to remove c:\fakepath that shows up as filepath in chrome browsers
export const formatChoosenFilePath = (fileToUpload: string): string | undefined => {
	return fileToUpload ? fileToUpload.replace(/^C:\\fakepath\\/i, "") : undefined;
};

// remove first 0 of phone number to match 3d secure
export const formatNumberTo3dSecure = (phone: string) => {
	const transformedString = phone.replace(/^0/, "");
	return transformedString;
};

export const formatWithNonBreakingSpaces = (str: string) => str.replace(/ /g, "\u00a0");

export const formatFullAccountNumber = (clearing: string, accountNumber: string) =>
	`${clearing} - ${accountNumber}`;
